import { render, staticRenderFns } from "./ImageShow.vue?vue&type=template&id=2675f726&scoped=true&"
import script from "./ImageShow.vue?vue&type=script&lang=js&"
export * from "./ImageShow.vue?vue&type=script&lang=js&"
import style0 from "./ImageShow.vue?vue&type=style&index=0&id=2675f726&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675f726",
  null
  
)

export default component.exports